import { useEffect, useState } from "react";

const LINES = [
  "$ initializing scan engine…",
  "$ cloning / reading source files…",
  "$ running pattern signatures (secrets, sql, rls)…",
  "$ invoking claude deep analysis…",
  "$ scoring & compiling report…",
];

export function ScanLoader() {
  const [visible, setVisible] = useState(1);
  useEffect(() => {
    const t = setInterval(() => setVisible((v) => Math.min(v + 1, LINES.length)), 1100);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="border border-border bg-[#080808] bg-grid p-6 font-mono text-sm" data-testid="scan-loader">
      {LINES.slice(0, visible).map((l, i) => (
        <div key={l} className="flex items-center gap-2 py-1 animate-fade-up">
          <span className={i === visible - 1 ? "text-neon" : "text-muted-foreground"}>{l}</span>
          {i === visible - 1 && <span className="w-2 h-4 bg-neon animate-blink inline-block" />}
        </div>
      ))}
      <p className="text-muted-foreground/50 text-xs mt-3">Deep analysis can take up to a minute for large repos.</p>
    </div>
  );
}
